import Person from "./Person";

export default class Student extends Person {
    personID: number;
    code: string;
    bosCode: string;
    yearLevel: string;
    rollClass: string;
    homeGroup: string;
    house: string;
    unitsToAssign: number;
    order: number;
    isUser: boolean;

    spareField1: string;
    spareField2: string;
    spareField3: string;

    constructor(data?: Partial<Student>) {
        super(data);
        Object.assign(this, data);
    }
}